import axios, { AxiosError, AxiosResponse, AxiosRequestConfig } from 'axios';

// eslint-disable-next-line import/no-cycle
import { appConfig, STORAGE_KEY_ACCESS_TOKEN } from 'src/config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: appConfig.apiUrl,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_KEY_ACCESS_TOKEN);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (res: AxiosResponse) => res,
  async (error: AxiosError) => interceptorsError(error),
);

export default axiosInstance;
// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

const interceptorsError = async (error: AxiosError) => {
  if (typeof localStorage !== 'undefined') {
    if (error.response?.status === 401) {
      localStorage?.removeItem(STORAGE_KEY_ACCESS_TOKEN);
      window.location.reload();
    }
  }

  const resError = (error.response && error.response) || 'Something went wrong';
  return typeof window === 'undefined' ? resError : resError;
};
